import { render, staticRenderFns } from "./baudRate.vue?vue&type=template&id=2dd72f4b&scoped=true"
import script from "./baudRate.vue?vue&type=script&lang=js"
export * from "./baudRate.vue?vue&type=script&lang=js"
import style0 from "./baudRate.vue?vue&type=style&index=0&id=2dd72f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd72f4b",
  null
  
)

export default component.exports